import _slicedToArray from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from 'react';
var EMPTY_KEYS = [];

function filterKeys(keys, dataKeys) {
  var filteredKeys = keys.filter(function (key) {
    return dataKeys.has(key);
  });
  return keys.length === filteredKeys.length ? keys : filteredKeys;
}

function flattenKeys(keys) {
  return Array.from(keys).join(';');
}

export default function useSelection(leftDataSource, rightDataSource) {
  var selectedKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_KEYS; // Prepare `dataSource` keys

  var _React$useMemo = React.useMemo(function () {
    return [new Set(leftDataSource.map(function (src) {
      return src.key;
    })), new Set(rightDataSource.map(function (src) {
      return src.key;
    }))];
  }, [leftDataSource, rightDataSource]),
      _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
      leftKeys = _React$useMemo2[0],
      rightKeys = _React$useMemo2[1]; // Selected Keys


  var _React$useState = React.useState(function () {
    return filterKeys(selectedKeys, leftKeys);
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      sourceSelectedKeys = _React$useState2[0],
      setSourceSelectedKeys = _React$useState2[1];

  var _React$useState3 = React.useState(function () {
    return filterKeys(selectedKeys, rightKeys);
  }),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      targetSelectedKeys = _React$useState4[0],
      setTargetSelectedKeys = _React$useState4[1]; // Fill selected keys


  React.useEffect(function () {
    setSourceSelectedKeys(filterKeys(selectedKeys, leftKeys));
    setTargetSelectedKeys(filterKeys(selectedKeys, rightKeys));
  }, [selectedKeys]); // Reset when data changed

  React.useEffect(function () {
    setSourceSelectedKeys(filterKeys(sourceSelectedKeys, leftKeys));
    setTargetSelectedKeys(filterKeys(targetSelectedKeys, rightKeys));
  }, [flattenKeys(leftKeys), flattenKeys(rightKeys)]);
  return [// Keys
  sourceSelectedKeys, targetSelectedKeys, // Updater
  setSourceSelectedKeys, setTargetSelectedKeys];
}